import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function RedirectIfAuthed({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600" />
      </div>
    );
  }
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}
